// extracted by mini-css-extract-plugin
export default {"footer":"light_footer__k-C5k","heartOverflow":"light_heartOverflow__q4Rkf","heart":"light_heart__wdyZ1"};